import React, { useState } from "react";
import { Telegram, Mail } from "@mui/icons-material";

function ContactDev() {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className="fixed w-40 h-20 inset-0 flex items-center justify-start z-50">
      {!isOpen && (
        <div className="px-4 py-3 rounded-xl bg-slate-200 h-auto flex flex-col justify-center items-center relative z-10">
          <button
            className="text-blueColor hover:bg-green-600 hover:text-white rounded-xl px-3 py-2 bg-green-300 font-semibold"
            onClick={handleOpen}
          >
            Open Contact
          </button>
        </div>
      )}
      {isOpen && (
        <div className="absolute w-screen h-screen inset-0 z-50 bg-gray-900 bg-opacity-75 flex items-center justify-center">
          <div className="w-screen sm:w-auto md:w-full py-3 rounded-xl bg-slate-200 h-auto flex flex-col justify-center items-center relative">
            <div className="h-auto py-3 rounded-xl bg-white sm:w-11/12 md:w-full lg:w-5/6 xl:w-11/12 mx-auto items-center flex flex-col justify-center shadow-md">
              <div className="sm:text-base md:text-lg lg:text-2xl xl:text-3xl mb-2 text-center mediumFont">
                Ushbu website{" "}
                <a
                  target="_blank"
                  className="text-blueColor"
                  href="https://asaxiy.uz/uz"
                >
                  asaxiy.uz
                </a>{" "}
                ning soxta nusxasi hisoblanadi!
              </div>
              <div className="text-base sm:text-sm md:text-base lg:text-lg xl:text-xl text-center normalFont sm:mt-1 md:mt-2 lg:mt-3 xl:mt-4">
                Dasturchi bilan bog'lanish uchun quyidagi havolalarni ustiga
                bosing
              </div>

              <a
                href="https://t.me/memberofns"
                className="flex font-semibold items-center mt-2 sm:mt-3 md:mt-4 lg:mt-5 xl:mt-6 text-blue-500 hover:text-blue-700"
                target="_blank"
              >
                <Telegram fontSize="medium" className="mr-2" />
                <span>Telegram</span>
              </a>

              <a
                href="mailto:ibrohimbek2701@gmail.com"
                className="flex items-center font-semibold mt-2 sm:mt-3 md:mt-4 lg:mt-5 xl:mt-6 text-red-500 hover:text-red-700"
                target="_blank"
              >
                <Mail fontSize="medium" className="mr-2" />
                <span>
                  <a
                    href="mailto:ibrohimbek2701@gmail.com"
                    className="text-red-500 hover:text-red-700"
                  >
                    Gmail
                  </a>
                </span>
              </a>
            </div>
            <button
              className="text-blueColor hover:bg-green-600 hover:text-white mt-3 sm:mt-4 md:mt-5 lg:mt-6 xl:mt-8 rounded-xl px-3 py-2 bg-green-300 font-semibold"
              onClick={handleClose}
            >
              Close Contact
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ContactDev;
